module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/food/bottle-2-c87bf9731f22c8e1fc55315d0bdaca09.svg";